(function () {
	const wrapperClasses = [
		"wrapper-per-row__1",
		"wrapper-per-row__2",
		"wrapper-per-row__3",
		"wrapper-per-row__4",
	];

	const applyPerRow = (perRow) => {
		const n = String(perRow);
		const container = document.querySelector("[data-productis-in-row]");
		if (!container) return;
		container.setAttribute("data-productis-in-row", n);
		const list = container.querySelector(
			"#product-grid.collection-product-list, ul#product-grid, .collection-product-list"
		);
		if (!list) return;
		list.classList.remove(...wrapperClasses);
		list.classList.add("wrapper-per-row__" + n);
	};

	const productsPerRow = () => {
		$(".per-row__button")
			.off("click.perRow")
			.on("click.perRow", function () {
				const n = $(this).data("per-row");
				$(".per-row__button").removeClass("active");
				$('.per-row__button[data-per-row="' + n + '"]').addClass("active");
				$(".per-row__button").attr("aria-pressed", function () {
					return $(this).data("per-row") === n ? "true" : "false";
				});
				applyPerRow(n);
			});
	};

	document.addEventListener("shopify:section:load", function () {
		productsPerRow();
	});
	productsPerRow();
})();
